import { createContext, useContext } from "react";
import { MapCanvasState } from "./MapCanvasContext.types";

export const MapCanvasContext = createContext<MapCanvasState | null>(null);

export const useMapCanvas = () => {
  const context = useContext(MapCanvasContext);
  if (!context) {
    throw new Error("useMapCanvas must be used within a MapCanvasProvider");
  }
  return context;
};
